import _ from '@lodash';
import { Input, Paper, Tooltip, Typography, withStyles } from '@material-ui/core';
import XAPPButton from 'app/Core/Components/Button/XAPPButton';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import classNames from 'classnames';
import MobileDetect from 'mobile-detect';
import React from 'react';
import { RiBankLine } from 'react-icons/ri';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import EmpresaFinanceiroExtratoDetalhe from './EmpresaFinanceiroExtratoDetalhe';
import * as Actions from './Store/Actions/EmpresaFinanceiroActions';

const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    footer: {
        display: 'flex',
        position: 'fixed',
        right: 30,
        bottom: 50,
        zIndex: 99
    },
    anotherLine: {
        backgroundColor: theme.palette.type === 'dark' ? '#303030' : '#D4D4D4'
    },
    root: {
        color: theme.palette.text.primary,
    },
    paper: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        borderRadius: '20px',
        width: '75%'
    },
    paperInativo: {
        backgroundColor: theme.palette.type === "dark" ? "#666" : "#CCC"
    }
});

class EmpresaFinanceiroExtrato extends XAPPComponent {

    state = {
        nome: ""
    };

    componentDidMount() {
        const xappRouteParams = this.props.match.params;
        this.listContas();
    }

    componentDidUpdate(prevProps, prevState) {
        const { setTitulo, EmpresaFinanceiro, idpessoaformularioconta } = this.props;
        if (!_.isEqual(prevProps.idpessoaformularioconta, idpessoaformularioconta)) {
            if (!_.isNull(idpessoaformularioconta)) {
                setTitulo(_.find(EmpresaFinanceiro.conta, { idpessoaformulario: idpessoaformularioconta }).nome);
            }
            else {
                setTitulo(null);
            }
        }
    }

    getContas = () => {
        const { EmpresaFinanceiro } = this.props;
        const form = this.state;
        var AResponse = [];

        if (EmpresaFinanceiro.conta !== null) {
            if (form.nome.length < 1) {
                return EmpresaFinanceiro.conta;
            }

            EmpresaFinanceiro.conta.forEach(item => {
                if (item.nome.toUpperCase().includes(form.nome.toUpperCase())) {
                    AResponse.push(item);
                }
            });
        }
        return AResponse;
    }

    handleChange = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.value));
    };

    listContas = () => {
        this.props.listContas('SELECIONAR', this.props.xappRouteParams);
    }

    render() {
        const { classes, data, idpessoaformularioconta, setConta, dataBase } = this.props;
        const xappRouteParams = this.props.match.params;
        const form = this.state;

        return (
            <React.Fragment>
                {idpessoaformularioconta === null ?
                    <React.Fragment>
                        <div className="flex">
                            <div className="flex-1" />
                            <XAPPButton
                                type="Icon"
                                className="py-8 px-12"
                                onClick={() => this.listContas()}
                                icon={"refresh"}
                            />
                        </div>
                        <div className="flex flex-col items-center justify-center pb-12">
                            <Paper component="div" className={classes.paper}>
                                <Input
                                    placeholder="Filtrar"
                                    className="flex w-full pl-12 py-4"
                                    disableUnderline
                                    fullWidth
                                    name="nome"
                                    value={form.nome}
                                    type='text'
                                    autoComplete="off"
                                    inputProps={{
                                        'aria-label': 'Filtar contas'
                                    }}
                                    onChange={this.handleChange}
                                />
                            </Paper>
                        </div>
                        <div className="flex justify-center flex-wrap">
                            {this.getContas().map(item => (
                                <Paper
                                    className={classNames("w-full h-300 lg:w-1/5 p-16 m-8 cursor-pointer")}
                                    id={"divmain_" + item.nome}
                                    onClick={() => setConta(item.idpessoaformulario)}
                                >
                                    <div className="flex flex-col items-center justify-center w-full py-8">
                                        <RiBankLine className="text-48" color="textSecondary" />
                                    </div>
                                    <div className="flex text-center justify-center w-full">
                                        <Tooltip title={item.nome}>
                                            <Typography className="text-18 font-400 pt-8" color="textSecondary">{item.nome.substring(0, 15)}</Typography>
                                        </Tooltip>
                                    </div>
                                </Paper>
                            ))}
                        </div>
                    </React.Fragment>
                    :
                    <React.Fragment>
                        <XAPPButton
                            tooltip={{ "title": "Voltar", "placement": "top" }}
                            type="Icon"
                            className="py-8 px-12"
                            onClick={() => setConta(null)}
                            icon={"rollback"}
                        />
                        <EmpresaFinanceiroExtratoDetalhe
                            xappRouteParams={xappRouteParams}
                            idpessoaformularioconta={idpessoaformularioconta}
                            setAcoes={this.props.setAcoes}
                            getAcoes={this.props.getAcoes}
                            data={data}
                            dataBase={dataBase}
                        />
                    </React.Fragment>
                }
            </React.Fragment>
        )
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        listExtrato: Actions.listExtrato,
        listContas: Actions.listContas,
        save: Actions.save,
    }, dispatch);
}

function mapStateToProps({ EmpresaFinanceiro, fuse }) {
    return {
        EmpresaFinanceiro: EmpresaFinanceiro,
        theme: fuse.settings.mainTheme,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(EmpresaFinanceiroExtrato)));
